var delta = delta || {};
delta.ajax = function () {
    var

    //flag indicating page is unloading, ajax errors are suppressed if true
    mUnloading = false,

    //error message displayed when an ajax error occurs.
    mErrorMsg = "An error has occurred",

    //
    //init
    //
    init = function() {
        //Setup default for ajax errors.  To suppress errors, add error function to post (see post function below)
        $.ajaxSetup({
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                if (!mUnloading) {
                    alert(mErrorMsg + ": " + errorThrown);
                }
            }
        });

        //set the unloading flag when leaving the page.
        $(window).bind("beforeunload", function() {
            mUnloading = true;
        });

    },


    //
    //post to an mvc controller.  To suppress error or use custom error handling, include err function.
    //
    post = function (url, data, callback, err) {
        //This one works with complex json objects
        $.ajax({
            type: 'post',
            url: addPageParams(url),
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (result) {
                if (!checkTimeout(result)) {
                    if (callback) {
                        callback(result);
                    }
                }
            },
            error: err
        });
    },

    //
    //synchronous post to MVC controller
    //
    postSync = function (url, data) {
        //$.post(
        //    url,
        //    data
        //);

        var ret = null;

        //This one works with complex json objects
        $.ajax({
            type: 'post',
            async: false,
            url: addPageParams(url),
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (result) {
                //if (!checkTimeout(result)) {
                    ret = result;
                //}
            }
        });

        return ret;
    },

    //
    // post a file, and optionally additional json data.
    // NOTE:  this posts as form data, not json.  The controller must accept form data
    //
    postFiles = function (
        url,

        // [] of input[type=file] IDs.  Do not include #
        fileIDs,  

        //additional non-file json data to post.  This will be converted for form data.
        //Can be null
        additionalJsonData,  

        callback
    ) {
        //create the form data
        var formData = new FormData();

        //append each file
        for (var id of fileIDs) {
            var file = document.getElementById(id).files[0];
            formData.append(id, file);
        }

        //append additional json data as form fields
        if (additionalJsonData) {
            for (var key in additionalJsonData) {
                if (additionalJsonData.hasOwnProperty(key)) {
                    formData.append(key, additionalJsonData[key]);
                }
            }
        }

        //post it
        $.ajax({
            type: 'POST',
            url: addPageParams(url),
            contentType: false,
            processData: false,
            data: formData,
            success: function(result) {
                if (callback) {
                    callback(result);
                }
            }
        });

    }

    //
    //get from a controller url.
    //
    get = function (url, callback) {
        //This one works with complex json objects
        $.get(
            addPageParams(url),
            function (result) {
                if (!checkTimeout(result)) {
                    if (callback) {
                        callback(result);
                    }
                }
            }
        );
    },

    //
    // perform a get, but eat any errors.  Usefull for polling.
    //
    getSuppressErrors = function(url, callback, errorCallBack) {
        $.ajax(
            addPageParams(url),
            {
                
                error: function() {
                    errorCallBack();
                },
                success: function(result) {
                    callback(result);
                }
            }
        );
    }

    //
    // Post FormData structure
    //
    postFormData = function (url, data, callback) {
        //how to get the data
        //      var formData = new FormData();
        //      _$wrapper.find('input,select').each(function() {
        //          var $elem = $(this);
        //          formData.append($elem.attr('name'), $elem.val());
        //      });        


        //post it
        $.ajax({
            type: 'POST',
            url: addPageParams(url),
            contentType: false,
            processData: false,
            data: data,
            success: function(result) {
                if (callback) {
                    callback(result);
                }
            }
        });
    },


    //
    //see if timeout was returned by ajax, returns the timeout url if session has timed out
    //
    checkTimeout = function(result) {
        if (result && typeof(result) == "object" && result.TimeoutUrl) {
            window.location = result.TimeoutUrl;
            return true;
        } else {
            return false;
        }
    },
    
    //
    // add the page params to the url
    //
    addPageParams = function(url) {
        //flag if our param exists
        var exists = false;
        
        var ar1 = url.split('?');
        if (ar1.length > 1) {
            var ar2 = ar1[1].split('&');

            for (var i=0; i<ar2.length; i++) {
                var ar3 = ar2[i].split('=');
                if (ar3[0].tolowerCase == 'pageparams') {
                    exists = true;
                    break;
                }
            }
        }

        if (!exists) {
            if (url.includes('?')) {
                url += '&' + delta.pageParams.getPageParams();
            } else {
                url += '?' + delta.pageParams.getPageParams();
            }
        }

        //return the new url
        return url;
    };

    

    //call init
    $(document).ready(init);

    return {
        post: post,
        postSync: postSync,
        get: get,
        getSuppressErrors: getSuppressErrors,
        postFiles: postFiles,
        postFormData: postFormData,
    };
}();